import React, { useRef } from 'react'
import { ArrowLeft, MoreVertical, Trash2 } from 'lucide-react'

const RightPanelHeader = ({
  selectedImage,
  selectedTool,
  inpaintingMode,
  inpaintingStep,
  versions,
  showMoreMenu,
  onMoreMenuToggle,
  onShowDeleteModal,
  onBack
}) => {
  const moreMenuRef = useRef(null)

  if (!selectedImage) return null

  const getHeaderTitle = () => {
    if (selectedTool === 'inpainting') {
      switch (inpaintingStep) {
        case 'create':
          return inpaintingMode === 'text' ? 'Write Description' : 'Draw Mask'
        case 'select':
          return 'Existing Masks'
        case 'prompt':
          return 'Configure Inpainting'
        default:
          return 'Generative Inpainting'
      }
    }
    return 'Edit Photo'
  }

  const getHeaderSubtitle = () => {
    if (selectedTool === 'inpainting') {
      switch (inpaintingStep) {
        case 'create':
          return inpaintingMode === 'text' 
            ? 'Describe the area you want to mask'
            : 'Draw the area you want to change'
        case 'select':
          return 'Choose an existing mask to use'
        case 'prompt':
          return 'Set your inpainting preferences'
        default:
          return 'Choose how to proceed'
      }
    }
    return `${versions.length} version${versions.length !== 1 ? 's' : ''} • Generated ${
      new Date(selectedImage.createdAt).toLocaleDateString('en-SG', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      })
    }`
  }

  if (selectedTool === 'inpainting') {
    return (
      <div className="flex items-center justify-between px-4 h-14 border-b border-gray-700">
        <div className="flex items-center gap-3">
          <button
            onClick={onBack}
            className="p-1.5 hover:bg-gray-700 rounded-md transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
          <div>
            <h2 className="font-medium">{getHeaderTitle()}</h2>
            <p className="text-xs text-gray-400">
              {getHeaderSubtitle()}
            </p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="flex items-center justify-between px-4 h-14 border-b border-gray-700">
      <div>
        <h2 className="font-medium">Edit Photo</h2>
        <p className="text-xs text-gray-400">
          {versions.length} version{versions.length !== 1 ? 's' : ''} • Generated {
            new Date(selectedImage.createdAt).toLocaleDateString('en-SG', {
              day: 'numeric',
              month: 'short',
              year: 'numeric'
            })
          }
        </p>
      </div>
      
      {/* Add more menu */}
      <div className="relative" ref={moreMenuRef}>
        <button
          onClick={() => onMoreMenuToggle(!showMoreMenu)}
          className="p-1.5 hover:bg-gray-700 rounded-md transition-colors"
        >
          <MoreVertical className="w-5 h-5" />
        </button>

        {showMoreMenu && (
          <div className="absolute right-0 top-full mt-1 bg-gray-800 rounded-lg shadow-lg border border-gray-700 py-1 min-w-[160px]">
            <button
              onClick={() => {
                onMoreMenuToggle(false)
                onShowDeleteModal(true)
              }}
              className="w-full px-3 py-2 text-left text-sm text-red-400 hover:bg-gray-700 flex items-center gap-2"
            >
              <Trash2 className="w-4 h-4" />
              Delete Photo
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default RightPanelHeader 